import LocalizedStrings from "react-localization"
import cs from "libs/localization/localization_cs"
import en from "libs/localization/localization_en"
// import nb from './localization_nb';

export const Localization = new LocalizedStrings({
  cs,
  en,
  // nb
})
